<template>
    <div class="contact-usage-progress">
        <div v-if="usageError" class="error-message">
            <ds-card class="reload-info">
                <ds-card-body>
                    <div class="reload-info-card-content">
                        <ds-icon name="info-circle" class="reload-icon" />

                        <span> {{ $options.MESSAGE_CONSTANTS.USAGE_ERROR }} </span>
                    </div>
                </ds-card-body>
            </ds-card>
        </div>

        <template v-else>
            <strong>{{ $options.MESSAGE_CONSTANTS.CONTACTS_TITLE }}</strong>

            <ds-progress-bar
                class="progress-bar"
                :progress="contactsUsed"
                :max="contactLimit"
                :label="`${contactsUsed} of ${contactLimit} contacts used`"
                hide-label-value
            />
        </template>
    </div>
</template>
<script>

export const MESSAGE_CONSTANTS = {
    CONTACTS_TITLE: 'Contacts',
    USAGE_ERROR: 'There was an error loading your usage for Contacts. Please refresh the page to try again.',
};

export default {
    MESSAGE_CONSTANTS,
    name: 'AccountContactUsage',

    props: {
        contactsUsed: Number,
        contactLimit: Number,
    },

    computed: {
        usageError() {
            return !this.contactLimit;
        },
    },
};
</script>

<style lang="scss" scoped>
    .contact-usage-progress {
        width: px-to-rem(350px);
    }

    .contact-usage-progress .error-message {
        margin: 30px 0 30px -30px;
        max-width: 100%;
    }

    .progress-bar {
        margin-top: 8px;
    }

    .reload-info {
        display: flex;
        box-shadow: none;
        border: solid px-to-rem(1px) $color-orange-050;
        background-color: $color-gray-100;
    }

    .reload-info-card-content {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
            @include margin-start($spacing-200);
        }
    }

    .reload-icon {
        --icon-color: #{$color-orange-700};
        margin: 0 0 0 $spacing-200;
    }
</style>
